import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-batch-id-cell-renderer',
  standalone: true,
  template: `
    <span class="batch-id-link" (click)="goToBatch()">
      {{ batchId }}
    </span>
  `,
  styles: [`
    .batch-id-link {
      color: #007bff;
      text-decoration: underline;
      cursor: pointer;
    }
  `]
})
export class BatchIdCellRendererComponent implements ICellRendererAngularComp {
// This component is used to render the batch_id as a clickable link
// It implements ICellRendererAngularComp to integrate with ag-Grid
// It receives the batch_id as a parameter and navigates to the batch details page when clicked

  batchId!: string;
  // Stored at init so it can be forwarded to the details page via router state.
  extractHdrId: string | null = null;
  private router!: Router;

agInit(params: any): void {
// This method is called by ag-Grid to initialize the component with parameters
// It receives the params object which contains the value for the batch_id
  this.batchId = params.value;
  // Capture the SAFE extract header id from the row data, falling back through known field name variants.
  this.extractHdrId = params.data?.extractHdrId ?? params.data?.extract_hdr_id ?? params.data?.entry_hdr_id ?? null;
  // Get router from the grid context
  this.router = params.context?.router;
}

  refresh(): boolean {
// This method is called by ag-Grid to refresh the component
// In this case, we do not need to refresh the component, so we return false
    return false;
  }

  goToBatch(): void {
    if (!this.batchId) {
      console.error('No batch ID available for navigation');
      return;
    }
    
    if (!this.router) {
      console.error('Router not available in cell renderer context');
      return;
    }
    
    // Pass extractHdrId in router state so the details page can display it without an extra API call.
    this.router.navigate(['/batch', this.batchId], {
      state: { extractHdrId: this.extractHdrId }
    });
  }
}
